export default {
  UNKNOWN: null, // 'Onbekend'
  ACTIVE: 0, // 'Actief'
  COMPLETED: 1, // 'Afgerond'
};
